"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignmentComplete = void 0;
const TeacherEntry_1 = require("../entries/TeacherEntry");
const Assignment_1 = require("./Assignment");
const AssignmentContent_1 = require("./AssignmentContent");
const AssignmentMeta_1 = require("./AssignmentMeta");
const AssignmentSettings_1 = require("./AssignmentSettings");
const lesson_1 = require("../lesson");
const AppError_1 = require("../errors/AppError");
const AssignmentBasicInfo_1 = require("./AssignmentBasicInfo");
var AssignmentComplete;
(function (AssignmentComplete) {
    function isHomework(data) {
        return data.type === 'homework';
    }
    AssignmentComplete.isHomework = isHomework;
    function isTest(data) {
        return data.type === 'test';
    }
    AssignmentComplete.isTest = isTest;
    function isRealtime(data) {
        return data.type === 'realtime';
    }
    AssignmentComplete.isRealtime = isRealtime;
    function from(content, meta, settings, teacherEntry) {
        if (!content || !meta || !settings) {
            return undefined;
        }
        return {
            _id: meta._id,
            type: meta.type,
            content,
            meta,
            settings,
            teacherEntry,
        };
    }
    AssignmentComplete.from = from;
    function asAssignmentData(data) {
        return {
            assignment: Assignment_1.Assignment.from(data.content, data.settings),
            meta: data.meta,
        };
    }
    AssignmentComplete.asAssignmentData = asAssignmentData;
})(AssignmentComplete || (exports.AssignmentComplete = AssignmentComplete = {}));
(function (AssignmentComplete) {
    function createFromLesson(type, assignmentId, lessonData, options, creationSettings, ownerId, teachers) {
        const createdAt = Date.now();
        const content = AssignmentContent_1.AssignmentContent.createFromLesson(assignmentId, ownerId, type, lessonData, createdAt, options);
        const settings = AssignmentSettings_1.AssignmentSettings.create(assignmentId, ownerId, createdAt, creationSettings);
        const teacherEntry = TeacherEntry_1.TeacherEntry.create(assignmentId, ownerId);
        const meta = AssignmentMeta_1.AssignmentMeta.createFromLesson(assignmentId, creationSettings.type, ownerId, createdAt, teachers, AssignmentBasicInfo_1.AssignmentBasicInfo.create(content), lessonData, options);
        return { content, meta, settings, type, _id: assignmentId, teacherEntry };
    }
    AssignmentComplete.createFromLesson = createFromLesson;
    /** creates a new object with updated contents */
    function updateWithLesson(type, old, lessonData, options, creationSettings) {
        const oldContent = old.content;
        const oldMeta = old.meta;
        const oldTeachers = old.meta.usersWithAccess;
        const oldTeacherEntry = old.teacherEntry;
        const updated = createFromLesson(type, old.meta._id, lessonData, options, creationSettings, old.meta.ownerId, oldTeachers);
        const settings = {
            ...updated.settings,
            status: old.settings.status,
            visibility: old.settings.visibility,
            migratedAt: oldContent.migratedAt,
        };
        return {
            _id: old._id,
            type: old.type,
            content: AssignmentContent_1.AssignmentContent.updateFromLesson(oldContent, lessonData, options),
            settings,
            meta: {
                ...updated.meta,
                createdAt: oldMeta.createdAt,
                summary: oldMeta.summary,
                migratedAt: oldContent.migratedAt,
            },
            teacherEntry: oldTeacherEntry,
        };
    }
    AssignmentComplete.updateWithLesson = updateWithLesson;
    function createHomeworkAssignment(assignmentId, lessonData, options, ownerId, teachers, isLinear) {
        const settings = {
            type: 'homework',
            visibility: 'all',
            status: 'open',
            restrictToGroup: !!options.restrictToGroup,
            isLinear,
        };
        if (options.showFinalSlide) {
            settings.showFinalSlide = {
                showSlide: true,
            };
        }
        return AssignmentComplete.createFromLesson('homework', assignmentId, lessonData, options, settings, ownerId, teachers);
    }
    AssignmentComplete.createHomeworkAssignment = createHomeworkAssignment;
    function createTestAssignment(assignmentId, lessonData, options, ownerId, teachers, lockStudents, randomiseQuestions, isLinear) {
        const settings = {
            type: 'test',
            visibility: 'all',
            status: 'open',
            lockStudents,
            randomiseQuestions,
            isLinear,
        };
        const data = AssignmentComplete.createFromLesson('test', assignmentId, lessonData, options, settings, ownerId, teachers);
        return data;
    }
    AssignmentComplete.createTestAssignment = createTestAssignment;
    function createRealtimeAssignment(assignmentId, pincode, lessonData, preferredPin, options, ownerId, ignoreExclusions, pincodeClosed, allowConnectedDevices, autoShowRank, isSoundEnabled, isRaiseHandAllowed) {
        const pin = preferredPin || lesson_1.LessonPin.firstPinForAssignmentType(lessonData.pins, 'realtime');
        if (!pin) {
            throw new AppError_1.AppError('not-found', `Missing pin for lesson`, { lessonId: lessonData.lesson._id });
        }
        const playerSettings = {
            allowConnectedDevices,
            isScreenShared: false,
            isPrepScreenEnabled: true,
            allowNewPlayers: !pincodeClosed,
            isRaiseHandAllowed,
            isSoundEnabled,
            autoShowRank,
            ignoreExclusions,
        };
        const settings = {
            type: 'realtime',
            visibility: 'all',
            status: 'open',
            nextAssignmentId: undefined,
            pincode,
            playerSettings,
            currentView: {
                pinId: pin.id,
                foregroundPinId: pin.id,
                hasNext: undefined,
                hasPrevious: undefined,
                progress: undefined,
                params: undefined, // always start without params
            },
        };
        const data = AssignmentComplete.createFromLesson('realtime', assignmentId, lessonData, options, settings, ownerId, [
            ownerId,
        ]);
        return data;
    }
    AssignmentComplete.createRealtimeAssignment = createRealtimeAssignment;
})(AssignmentComplete || (exports.AssignmentComplete = AssignmentComplete = {}));
//# sourceMappingURL=AssignmentComplete.js.map